import React from 'react';

const ImageSlider = ({ type, imageList, item, selectedImage, setSelectedImage }) => {
	const onSetCurrentImage = (item) => {
		const index = selectedImage.findIndex((image) => image.id === item.id);
		if (index !== -1) {
			const updatedSelectedImage = [...selectedImage];
			updatedSelectedImage[index] = item;
			setSelectedImage(updatedSelectedImage);
		} else {
			setSelectedImage((prevSelectedImage) => [...prevSelectedImage, item]);
		}
	};

	const onGetCurrentImage = (id) => selectedImage?.find((image) => image?.id === id)?.imageIndex || 0;

	return (
		<>
			<div className="data-cell-slider card-top cursor-pointer">
				{imageList &&
					imageList?.length >= 0 &&
					imageList[onGetCurrentImage(item?.id)]?.documentResponse?.docUrl &&
					(type !== 'CARD_VIEW' ? (
						<>
							<div className="cell-single">
								<div className="img">
									<img
										src={imageList[onGetCurrentImage(item?.id)]?.documentResponse?.docUrl}
										alt="Image"
									/>
								</div>
								<div className="cart-title">
									<h3 className="gray_dark_01 text-center regular-14 weight-700 mb-1">
										{imageList[onGetCurrentImage(item?.id)]?.name}
									</h3>
									<h3 className="text-center regular-14">
										{imageList[onGetCurrentImage(item?.id)]?.subCategoryName}
									</h3>
								</div>
							</div>
						</>
					) : (
						<>
							<img
								src={imageList[onGetCurrentImage(item?.id)]?.documentResponse?.docUrl}
								alt="Image"
							/>
							<div className="cart-title">
								<h3 className="gray_dark_01 text-center regular-14 weight-700">
									{item?.bodyPart?.name}
								</h3>
							</div>
						</>
					))}

				<div className="slider-arrow">
					<span
						className="arrow left-arrow"
						onClick={(e) => {
							e.stopPropagation();
							if (onGetCurrentImage(item?.id) !== 0) {
								onSetCurrentImage({
									id: item?.id,
									imageIndex: onGetCurrentImage(item?.id) - 1
								});
							}
						}}
					>
						<img src={`${process.env.PUBLIC_URL}/icons/Left-arrow.svg`} alt="Previous" />
					</span>
					<span
						className="arrow right-arrow"
						onClick={(e) => {
							e.stopPropagation();
							if (onGetCurrentImage(item?.id) < imageList?.length - 1) {
								onSetCurrentImage({
									id: item?.id,
									imageIndex: onGetCurrentImage(item?.id) + 1
								});
							}
						}}
					>
						<img src={`${process.env.PUBLIC_URL}/icons/right-arrow.svg`} alt="Next" />
					</span>
				</div>
			</div>
			<div className="slider-count count">
				<span className="status gray_light_03 gray-1">
					{onGetCurrentImage(item?.id) + 1}/{imageList?.length}
				</span>
			</div>
		</>
	);
};

export default ImageSlider;
